import React from 'react';
import { Link } from 'react-router-dom';
import { contacts, socialLinks, messageLinks } from '../../config/contacts';
import { MapPin } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          {/* Pino AI Section - 2 columns */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-bold text-white mb-4">Pino AI</h3>
            <p className="text-gray-400 mb-4">
              Transforming digital presence through AI-powered solutions.
            </p>
            <div className="flex items-start space-x-2">
              <MapPin className="w-5 h-5 mt-1 text-purple-400" />
              <div>
                <p className="text-gray-400">San Leandro, California USA</p>
                <p className="text-gray-400">San Leonardo, Nueva Ecija, Philippines</p>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="hover:text-purple-400">Services</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-purple-400">About Us</Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-purple-400">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Contact Us */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Contact Us</h4>
            <ul className="space-y-2">
              {contacts.map((contact, index) => {
                const Icon = contact.icon;
                if (contact.type !== 'Address') {
                  return (
                    <li key={index} className="flex items-center">
                      <Icon className="w-5 h-5 mr-2" />
                      {contact.href ? (
                        <a href={contact.href} className="hover:text-purple-400">
                          {contact.value}
                        </a>
                      ) : (
                        <span>{contact.value}</span>
                      )}
                    </li>
                  );
                }
                return null;
              })}
            </ul>
          </div>

          {/* Follow Us */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Follow Us</h4>
            <ul className="space-y-2">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <li key={index}>
                    <a
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center hover:text-purple-400"
                    >
                      <Icon className="w-5 h-5 mr-2" />
                      {social.name}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Message Us */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Message Us</h4>
            <ul className="space-y-2">
              {messageLinks.map((message, index) => {
                const Icon = message.icon;
                return (
                  <li key={index}>
                    <a
                      href={message.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center hover:text-purple-400"
                    >
                      <Icon className="w-5 h-5 mr-2" />
                      {message.name}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center">
          <p>&copy; {currentYear} Pino AI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}